import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../modules/auth/services/auth.service';
import { Router } from '@angular/router';
import { Permissions } from '../../modules/auth/permissions/permissions';
import { vendorRoutes } from '../../routes/vendor.routes';
import { adminRoutes } from '../../routes/admin.routes';
import { deliveryAdminRoutes } from '../../routes/delivery-admin.routes';
import { baseRoutes } from '../../app.routes';
import { customerRoutes } from '../../routes/customer.routes';

@Injectable({
  providedIn: 'root'
})
export class DynamicRouterService {

  authService = inject(AuthService);
  router = inject(Router);

  updateRoutesBasedOnRole() {
    let newRoutes = [...baseRoutes];

    if (this.authService.hasPermission(Permissions.IS_VENDOR)) {
      newRoutes.push(...vendorRoutes);
    } else if (this.authService.hasPermission(Permissions.IS_SUPER_ADMIN)) {
      newRoutes.push(...adminRoutes);
    } else if (this.authService.hasPermission(Permissions.IS_DELIVERY_MANAGER)) {
      newRoutes.push(...deliveryAdminRoutes);
    } else if (this.authService.hasPermission(Permissions.IS_CUSTOMER)) {
      newRoutes.push(...customerRoutes);
    }

    newRoutes.push({
      path: '**',
      redirectTo: this.authService.isLoggedIn() ? '' : 'login',
    });

    this.router.resetConfig(newRoutes);
  }
}
